import React from 'react';

export type BETA_JRCDoubleClickProps = {
    children: React.ReactNode;
    onDoubleTap: () => void;
    onDoubleTapMsDelay?: number;
};

export const BETA_JRCDoubleClick = ({ children, onDoubleTap, onDoubleTapMsDelay = 400 }: BETA_JRCDoubleClickProps) => {
    const [tap, setTap] = React.useState<number>(0);

    React.useEffect(() => {
        if (tap > 1) {
            onDoubleTap();
            setTap(0);
        }
    }, [tap, onDoubleTap]);

    const onClick = () => {
        setTap(tap + 1);
        setTimeout(() => {
            setTap(0);
        }, onDoubleTapMsDelay);
    };
    return <div onClick={onClick}>{children}</div>;
};
